import { TableCell, TableRow } from "@/components/ui/table";
import React from "react";

const OrderLoader = () => {
  return (
    <TableRow className="border-primary-light/30 animate-pulse">
      <TableCell className="px-4 py-6">
        <div className="h-6 w-40 rounded bg-gray-200" />
      </TableCell>
      <TableCell className="px-4 py-6">
        <div className="h-6 w-24 rounded bg-gray-200" />
      </TableCell>
      <TableCell className="px-4 py-6">
        <div className="h-6 w-20 rounded bg-gray-200" />
      </TableCell>
      <TableCell className="px-4 py-6">
        <div className="h-6 w-20 rounded bg-gray-200" />
      </TableCell>
      <TableCell className="px-4 py-6">
        <div className="h-6 w-20 rounded bg-gray-200" />
      </TableCell>
      <TableCell className="px-4 py-6 text-right">
        <div className="mx-auto h-9 w-24 rounded bg-gray-200" />
      </TableCell>
    </TableRow>
  );
};

export default OrderLoader;
